<template>
  <v-card elevation="1" class="pa-4 pa-sm-8" :style="{ borderRadius: '16px' }">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="header-style">
          <span>{{
            refCode === "moph" ? "รายละเอียดหน่วยบริการ" : "รายละเอียดองค์กร"
          }}</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" class="my-6">
        <v-row no-gutters align-content="center">
          <v-col cols="auto">
            <span class="title-organize">
              {{ refCode === "moph" ? "ประเภทหน่วยบริการ :" : "ขนาดองค์กร :" }}
            </span>
          </v-col>
          <v-col cols="auto">
            <div class="text-detail pl-3">
              {{ refCode === "moph" ? serviceUnitType : organizationSize }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="refCode !== 'moph'">
        <div class="pb-1">
          <span class="header-style">เกี่ยวกับ</span>
          <div
            class="text-detail pl-3 pt-3"
            v-html="displayOrNot(businessDetails?.business_detail)"
          ></div>
        </div>
      </v-col>

      <!-- Products & Services -->
      <v-col cols="12" v-if="refCode !== 'moph'">
        <div
          class="text-detail pl-3"
          v-html="displayOrNot(businessDetails?.products_and_services)"
        ></div>
      </v-col>
      <v-col cols="12" class="pb-6">
        <div class="pb-1">
          <span class="header-style">สวัสดิการ</span>
          <div
            class="text-detail pl-3 py-3"
            v-html="displayOrNot(businessDetails?.welfare)"
          ></div>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="pb-6"
        v-if="
          businessDetails?.business_payments?.length &&
          isPaymentComplete(businessDetails.business_payments[0]) &&
          refCode === 'moph'
        "
      >
        <div class="pb-1">
          <span class="header-style">ช่องทางการชำระเงิน</span>
          <div class="mt-4">
            <PayMentDetail
              :paymentDetail="businessDetails.business_payments[0]"
            />
          </div>
        </div>
      </v-col>
      <v-col
        style="background-color: #fbfbfb; padding: 16px; border-radius: 8px"
      >
        <v-row cols="12" no-gutters class="pb-4">
          <v-col cols="12" sm="6" class="text-title">เว็บไซต์</v-col>
          <v-col cols="12" sm="6" class="text-sub-detail">
            <div v-if="businessDetails?.website_All?.length">
              <div
                v-for="(item, index) in businessDetails.website_All"
                :key="index"
              >
                <a @click.prevent="openWebsite(item.website)">
                  <span style="color: #2b60e1; text-decoration: underline">
                    {{ item.website || "" }}
                    <v-icon color="#2B60E1"
                      >mdi-arrow-top-right-thin-circle-outline</v-icon
                    >
                  </span>
                </a>
              </div>
            </div>
            <div v-else>ไม่ระบุ</div>
          </v-col>
        </v-row>

        <v-row cols="12" no-gutters class="pb-4">
          <v-col cols="12" sm="6" class="text-title">เบอร์โทรศัพท์</v-col>
          <v-col cols="12" sm="6" class="text-sub-detail">
            <div v-if="businessDetails?.contacts?.length">
              <div
                v-for="(contact, index) in businessDetails.contacts"
                :key="index"
              >
                <span v-if="contact.contact_name">{{
                  contact.contact_name
                }}</span>
                {{ contact.phone_number || "" }}
                <span v-if="contact.extension"
                  >ต่อ {{ contact.extension }}</span
                >
              </div>
            </div>
            <div v-else-if="businessDetails?.mobile_no">
              {{ businessDetails.mobile_no }}
            </div>
            <div v-else>ไม่ระบุ</div>
          </v-col>
        </v-row>

        <v-row cols="12" no-gutters class="pb-4">
          <v-col cols="12" sm="6" class="text-title">อีเมล</v-col>
          <v-col cols="12" sm="6" class="text-sub-detail">
            {{
              businessDetails?.hr_email || businessDetails?.email || "ไม่ระบุ"
            }}
          </v-col>
        </v-row>

        <v-row cols="12" no-gutters>
          <v-col cols="12" sm="6" class="text-title">สถานที่ตั้ง</v-col>
          <v-col cols="12" sm="6" class="text-sub-detail">
            <p>
              <template v-if="businessDetails?.business_address">
                {{ businessDetails.business_address }},
              </template>
              {{
                [
                  businessDetails?.sub_district_name,
                  businessDetails?.district_name,
                  businessDetails?.province_name,
                  businessDetails?.postal_code,
                ]
                  .filter(Boolean)
                  .join(", ") || "ไม่ระบุ"
              }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import PayMentDetail from "../../Payment/PaymentDetail.vue";

export default {
  name: "BusinessDetails",
  props: {
    business_data: Object,
    showProfileAddSuccess: Boolean,
  },
  components: { PayMentDetail },
  data() {
    return {
      businessDetails: {},
      refCode: localStorage.getItem("refcode") || "-",
      loading: true,
    };
  },
  mounted() {
    this.fetchBusinessDetails();
  },
  watch: {
    business_data: {
      immediate: true,
      handler(newValue) {
        this.businessDetails = newValue;
      },
    },
  },
  computed: {
    ...mapGetters({ position_role: "position_role", user: "user" }),
    organizationSize() {
      return this.businessDetails?.organization_size_th || "ไม่ระบุ";
    },
    serviceUnitType() {
      return this.businessDetails?.service_unit_type_th || "ไม่ระบุ";
    },
  },
  methods: {
    displayOrNot(value) {
      return value ?? "ไม่ระบุ";
    },
    async fetchBusinessDetails() {
      try {
        const businessId = localStorage.getItem("business_id");
        if (!businessId) return;

        const response = await this.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/show-business/${businessId}`
        );

        if (response.data.success) {
          this.$store.commit(
            "setReferralStatus",
            response.data.data.referral_status
          );
          this.businessDetails = response.data.data;
        } else {
          console.error(
            "Failed to fetch business details:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error fetching business details:", error);
      }
      this.loading = false;
    },
    isPaymentComplete(payment) {
      const { bank_id, bank_account_no, bank_account_name, bank_other_name } =
        payment ?? {};
      if (!bank_id || !bank_account_no || !bank_account_name) return false;
      if (bank_id === 28 && !bank_other_name) return false;
      return true;
    },
    openWebsite(url) {
      if (url) window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.text-detail {
  font-size: 18px;
  color: #333;
}
.text-title {
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
  color: #333;
}
.text-sub-detail {
  font-size: 16px;
  line-height: 30px;
  color: #333;
}
.title-organize {
  font-size: 18px;
  color: #333;
  font-weight: 600;
  line-height: 26px;
}
.header-style {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  text-align: left;
}
.v-card {
  background: #fff;
  border-radius: 8px;
}
</style>
